<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Downloads</h2>
    <v-divider></v-divider>
    <br />
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <br />
          <h5>Investor Agreement :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            <template
              v-if="downloads.investor_agreement && downloads.invested_by"
            >
              <a
                :href="`${fileUrl}/investor_agreement/${downloads.invested_by}/${downloads.investor_agreement}`"
                target="_blank"
              >
                <img
                  width="80px"
                  height="auto"
                  :src="pdfImage()"
                  alt="Investor Agreement"
                />
              </a>
            </template>
            <template v-else>-</template>
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <br />
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <br />
          <h5>Investee Agreement :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            <template v-if="downloads.investee_agreement && downloads.user_id">
              <a
                :href="`${fileUrl}/investee_agreement/${downloads.user_id}/${downloads.investee_agreement}`"
                target="_blank"
              >
                <img
                  width="80px"
                  height="auto"
                  :src="pdfImage()"
                  alt="Investee Agreement"
                />
              </a>
            </template>
            <template v-else>-</template>
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
  </v-list>
</template>
<script>
  export default {
    props: ["downloads"],
    data() {
      return {
        fileUrl: process.env.VUE_APP_FILE_URL,
      };
    },
    methods: {
      pdfImage() {
        return require("@/assets/pdf.png");
      },
    },
  };
</script>
